module.exports = __webpack_public_path__ + "img/img-exercise-muscle-01.712b370e.png";